import { customAlphabet } from "nanoid";
import type { Vector3 } from "three";

export enum IdPrefix {
	Background = "B",
	Horizontal = "H",
	Vertical = "V",
	Compartment = "C",
	Shelf = "S",
	Door = "D",
}

export function generateId(prefix: IdPrefix) {
	const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
	const nanoid = customAlphabet(alphabet, 4);

	return `${prefix}-${nanoid()}`;
}

export function calculcateCameraZPosition(
	fov: number,
	aspect: number,
	size: Vector3,
	offset = 1.4,
) {
	const fovv = fov * (Math.PI / 180);
	const fovh = 2 * Math.atan(Math.tan(fovv / 2) * aspect);
	const dx = size.z / 2 + Math.abs(size.x / 2 / Math.tan(fovh / 2));
	const dy = size.z / 2 + Math.abs(size.y / 2 / Math.tan(fovv / 2));
	let cameraZ = Math.max(dx, dy);

	// offset the camera, if desired (to avoid filling the whole canvas)
	if (offset !== undefined && offset !== 0) cameraZ *= offset;

	return cameraZ;
}

export const adjustDimension = (current: number, min: number, max: number): number => {
	return Math.min(Math.max(current, min), max);
};
